import ErrorPage from './error-page';
import {useGetTrackingErrorsQuery} from '../features/api/apiSlice';

export const ClaimExpired = () => {
  const {data: trackingErrors} = useGetTrackingErrorsQuery();
  return <ErrorPage body={trackingErrors?.errorBody} title={trackingErrors?.claimExpired} />;
};

export const PageNotFound = () => {
  const {data: trackingErrors} = useGetTrackingErrorsQuery();
  return <ErrorPage body={trackingErrors?.errorBody} title={trackingErrors?.pageNotFound} />;
};

export const InvalidRepairId = () => {
  const {data: trackingErrors} = useGetTrackingErrorsQuery();
  return <ErrorPage body={trackingErrors?.errorBody} title={trackingErrors?.invalidRepairId} />;
};

export const NoRepairFound = () => {
  const {data: trackingErrors} = useGetTrackingErrorsQuery();
  return <ErrorPage body={trackingErrors?.errorBody} title={trackingErrors?.repairNotFound} />;
};
